module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAQCAYAAAAvf+5AAAAAAXNSR0IArs4c6QAAAQtJREFUKFN10r8rhVEYwPHvt0hKNoPBYLBYrMpiMkhKikExmQ26A0osLCwGuwEDiZTBjyz+Dn+FROhxHx0397rvWd63cz6d59cxIlaBTWBNPaRiGRFHwCIQQE3db2cT9gI3wFgB6+puKzY3IqIHuAbGC9hSt//iH1hwN3AJTJStHXXj97wBC+4CzoGpAvbUWv43wYI7gVNgtuADdeUfLLgDOAbmCl6ugn31LtwBI8AXMNkudD9wDwwDn8CSetJazADwUA87BHwAC+pZUzH1CQ0WlN93YF69ampPROQNeVPe+JYVqzmtxsoRZi6ZU+b2Csyot/9GGBHPQIZ7AabVx6pHcQGMZs/Up6pn9g0wa1a1cpaR6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/gameHome/path.png
// module id = Bl60
// module chunks = 52